module.exports = __webpack_public_path__ + "assets/img/demoAccess/subjects/13/details-small2.png";